<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__sidewalk' : 'collapsible collapsed collapsible__sidewalk'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img v-show="expand == true" :src="LaneClosureRequest.getSidewalkImageLight(sidewalkId)"></b-img>
									<b-img v-show="expand != true" :src="LaneClosureRequest.getSidewalkImage(sidewalkId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">{{LaneClosureRequest.getSidewalkText(sidewalkId)}}</div>
								<div class="collapsible-heading__status" @click="onToggleExpand"><div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseSidewalkListing" @click="onToggleExpand">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<b-collapse id="collapseSidewalkListing" :visible="expand" class="collapsible-entries">
							<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'bls2index'+b2index+'-'+renderCounter">
								<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index)"></div>
								<div class="flex-grow-1 ">
									<div class="d-flex collapsible-entry__title-wrapper">
										<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
										<div class="collapsible-entry__map-button">
											<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<!-- end of desktop -->



					<div v-if="$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__sidewalk' : 'collapsible collapsed collapsible__sidewalk'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getSidewalkImage100(sidewalkId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getSidewalkText(sidewalkId)}}
								</div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseSidewalkListing" @click="onToggleExpand">
											<span>
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile && expand">
						<transition  name="slide-fade" tag="div">
						<div class="d-block section-slide-panel has-menu" v-if="showPanel">
								<div class="top-controls">
									<span @click="onApply">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</span>
								</div>
								<div class="panels-body panels-body-padded">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div class="panels-primary-title" v-html="getModalTitle"></div>
									<div class="d-flex lcr--restriction--legend"><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-close.svg" alt="" /><span class="status-circle__label">Closed</span></div><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-open.svg" alt="" /><span class="status-circle__label">Open</span></div><div class="lcr-summary__status-legend"><img src="/img/assets/not-reported.svg" alt=""/><span class="status-circle__label"> Not Reported</span></div></div>
									<div class="panels-body-content">
									<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'bls2index'+b2index+'-'+renderCounter">
										<div class="collapsible-entry__icon pt-2" v-html="getInEffectIcon(b2index)"></div>
										<div class="flex-grow-1 ">
											<div class="d-flex collapsible-entry__title-wrapper">
												<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
												<div class="collapsible-entry__map-button">
													<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
												</div>
											</div>
										</div>
									</div>
									</div>
								</div>
								<div class="panels-apply" v-if="canReport">
									<div class="d-flex">
										<div  class="panels-apply__back"><b-button @click="onReport" variant="primary" class="save-button ml-2" type="button">Report Sidewalk Opened or Closed</b-button></div>
									</div>
								</div>

							</div>
						</transition>
					</div>

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>
<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'ViewLaneClosureRequestBlockSidewalkListing',
	props: ['value', 'preset', 'sidewalkId', 'expand', 'canReport'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			renderCounter: 0,
			backup: {},
			showPanel: false
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
	watch: {

	},
	computed: {
		getNavTitle() {
			return "Closures";
		},
		getModalTitle() {
			return LaneClosureRequest.getSidewalkText(this.sidewalkId);
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.sidewalk) {
					for (x = 0; x < entry.sidewalk.length; x++) {
						if (entry.sidewalk[x].sidewalkId.value == that.sidewalkId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.sidewalk) {
					for (x = 0; x < entry.sidewalk.length; x++) {
						if (entry.sidewalk[x].sidewalkId.value == that.sidewalkId) {
							return false;
						}
					}
				}
				return true;
			})
		},
	},
	methods: {
		getInEffectTitle() {
			var texts = [];
			var hasBlocks = false;

			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].sidewalk.length; x++) {
						if (this.value[index].sidewalk[x].sidewalkId.value == this.sidewalkId) {
							if (texts["" + this.value[index].sidewalk[x].inEffect.value]) {} else {
								texts["" + this.value[index].sidewalk[x].inEffect.value] = 0;
							}
							texts["" + this.value[index].sidewalk[x].inEffect.value]++;
							hasBlocks = true;
						}
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle lc-closed'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle lc-open'>" + texts["0"] + "</div>";
			}
			if (texts["null"] > 0) {
				// not reported
				html += "<div class='status-circle lc-not-reported'>" + texts["null"] + "</div>";
			}

			if (!hasBlocks) {
				html = "<div>NO BLOCKS</div>";
			}
			return html;
		},
		getInEffectText(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].sidewalk.length; x++) {
						if (this.value[index].sidewalk[x].sidewalkId.value == this.sidewalkId) {
							return LaneClosureRequest.getSidewalkInEffectText(this.value[index].sidewalk[x].inEffect.value);
						}
					}
				}
			}
			return null;
		},
		getInEffectIcon(index) {
			var texts = [];
			if (this.value) {
				for (var x = 0; x < this.value[index].sidewalk.length; x++) {
					if (this.value[index].sidewalk[x].sidewalkId.value == this.sidewalkId) {
						if (texts["" + this.value[index].sidewalk[x].inEffect.value]) {} else {
							texts["" + this.value[index].sidewalk[x].inEffect.value] = 0;
						}
						texts["" + this.value[index].sidewalk[x].inEffect.value]++;

					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				// html += "<div class='status-circle-solid lc-closed'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';
			}
			if (texts["0"] > 0) {
				// open
				// html += "<div class='status-circle-solid lc-open'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-open.svg" alt="" />';
			}
			if (texts["null"] > 0) {
				// not reported
				html += "<div class='status-circle-solid lc-not-reported'>&nbsp;</div>";
			}
			return html;
		},
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			if (this.isEntry(index)) {
				return "d-flex collapsible-entry";
			} else {
				return "d-flex collapsible-entry";
			}
		},
		isEntry: function(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].sidewalk.length; x++) {
						if (this.value[index].sidewalk[x].sidewalkId.value == this.sidewalkId) {
							return true;
						}
					}
				}
			}
			return false;
		},
		switchId(prefix, block, id) {
			return prefix + "-" + block + "-" + id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-sidewalk", id);
		},
		showOnMap: function(id) {
			Vue.prototype.$bus.$emit("block:show-on-map", {id, type: "sidewalk", laneId: this.sidewalkId});
		},
		addBlock: function(sidewalkId, blockId) {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-add-sidewalk", { sidewalkId: sidewalkId, blockId: blockId });
		},
		toggleRemoveBlock: function(index) {
			this.renderCounter++;
			if (this.isEntry(index)) {
				Vue.prototype.$bus.$emit("block:list-remove-sidewalk", { sidewalkId: this.sidewalkId, blockId: this.value[index].blockId });
			} else {
				Vue.prototype.$bus.$emit("block:list-add-sidewalk", { sidewalkId: this.sidewalkId, blockId: this.value[index].blockId });
			}
		},
		onReview: function() {
			Vue.prototype.$bus.$emit("block:list-expand-sidewalk", { sidewalkId: this.sidewalkId, expand: true });
		},
		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-sidewalk", { sidewalkId: that.sidewalkId, expand: !that.expand });
			}, 250);
		},
		onReport() {
			Vue.prototype.$bus.$emit("block:report-lane-closure", null);
		},
		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
				setTimeout(() => {
					let that = this;
					Vue.prototype.$bus.$emit("block:list-expand-sidewalk", { sidewalkId: that.sidewalkId, expand: !that.expand });
				}, 250);
			}
		},
		onToggleExpand: function() {
			this.renderCounter++;

			Vue.prototype.$bus.$emit("block:list-expand-sidewalk", { sidewalkId: this.sidewalkId, expand: !this.expand });
		},

	}
}
</script>